// eslint-disable-next-line
import React, { FC } from 'react';

import AR from 'assets/images/AR.svg';
import PY from 'assets/images/PY.svg';
import UY from 'assets/images/UY.svg';

export type FlagProps = {
  countryCode: string;
};

const flags = {
  AR,
  PY,
  UY,
};

const Flag: FC<FlagProps> = ({ countryCode }) => {
  const src = flags[countryCode];
  if (src) {
    return <img src={PY} alt="Bandera de pais" height="20px" />;
  }

  return null;
};

export default Flag;
